module.exports = __webpack_public_path__ + "static/img/2018.740476a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2018.png
// module id = q8JD
// module chunks = 1